import AvgButton from '../ComControl/AvgButton'
import GameMallNewModel from './GameMallNewModel'
import FileItem from '../FileItem'
import DataUtils from '../DataUtils'
import { FileReader, FileWriter } from '@/platform'

class MallNewInput {
    public Version: number = 1 // 表示当前ouisf文件的版本号，用于数据的兼容
    public GameMallNew: GameMallNewModel = new GameMallNewModel() // 商城3.0数据结构
    public FileItemList: Array<FileItem> = [] // 商城3.0文件系统列表
    public ButtonList: Array<AvgButton> = [] // 商城3.0按钮列表

    get fileListStart() {
        return this._fileListStart
    }

    private _fileListStart = 0
    private FontColor_UI: string = '' // 字体

    private search: { Width: number; Height: number } // 分辨率

    constructor(
        dataVersion: number = DataUtils.dataVersion,
        FontColor_UI: string = '255,255,255',
        search: { Width: number; Height: number } = { Width: 960, Height: 540 }
    ) {
        this.FontColor_UI = FontColor_UI
        this.search = search
    }

    readData(reader: FileReader, dataVersion: number): void {
        this.readLegacyData(reader, dataVersion)
    }

    readLegacyData(reader: FileReader, dataVersion: number): void {
        this.Version = reader.readInt()
        this.GameMallNew = new GameMallNewModel(this.FontColor_UI, this.search)
        this.GameMallNew.readVersionedOui(reader, dataVersion, true)

        let length = reader.readInt()
        for (let index = 0; index < length; index++) {
            const fileItem = new FileItem()
            fileItem.readVersionedOui(reader.readObj(reader.readInt()))
            this.FileItemList.push(fileItem)
        }

        length = reader.readInt()
        for (let index = 0; index < length; index++) {
            const btn = new AvgButton()
            btn.readVersionedOui(reader.readObj(reader.readInt()))
            this.ButtonList.push(btn)
        }
    }

    writeData(writer: FileWriter, IsUI = false): void {
        this.writeLegacyData(writer, IsUI)
    }

    writeLegacyData(writer: FileWriter, IsUI = false): void {
        writer.writerIntLength()

        writer.writeInt(this.Version)
        this.GameMallNew.writeVersionedOui(writer, true)

        writer.writeInt(this.FileItemList.length)
        this.FileItemList.forEach(item => {
            item.writeVersionedOui(writer)
        })

        writer.writeInt(this.ButtonList.length)
        this.ButtonList.forEach(item => {
            item.writeVersionedOui(writer)
        })

        writer.writerLength()
    }
}
export default MallNewInput
